import React from 'react';

import { AccordionItem } from '@radix-ui/react-accordion';
import { useTranslation } from 'react-i18next';

import { ReactComponent as InfoIcon } from '@pkg/assets/icons/info-icon.svg';
import { Popover, Tooltip } from '@pkg/components/Elements/Tooltip';
import { Badge } from '@pkg/components/Sections/Profile/Badge';
import { StyledLink } from '@pkg/components/Sections/Profile/Filters/FilterSpam/styles';
import { useTablet } from '@pkg/hooks';

import { Switch } from '../../Switch';
import { FilterContent, FilterHeading } from '../Filter';

import { HeadingIconWrapper } from './styles';

export type FilterShowHideProps = {
    index: string;
    onChange: (filter: string, value: boolean) => void;
    spam: boolean;
    unsupported: boolean;
};

export const FilterShowHide = ({ index, onChange, spam, unsupported }: FilterShowHideProps) => {
    const { t } = useTranslation(['common']);
    const isTablet = useTablet();
    const title = t('filter_show_hide');

    return (
        <AccordionItem value={index}>
            <FilterHeading disableUpperCase>{title}</FilterHeading>
            <FilterContent>
                <Switch
                    id="filter-unsupported"
                    label={t('filter_show_hide_unsupported_label')}
                    value="unsupported"
                    checked={unsupported}
                    onCheckedChange={(value) => onChange('unsupported', value)}
                >
                    <HeadingIconWrapper>
                        <Tooltip trigger={<InfoIcon />} placement={isTablet ? 'bottom-start' : 'bottom-end'}>
                            {t('filter_unsupported_tooltip')}
                        </Tooltip>
                    </HeadingIconWrapper>
                </Switch>

                <Switch
                    id="filter-spam"
                    label={t('filter_show_hide_spam_label')}
                    value="spam"
                    checked={spam}
                    onCheckedChange={(value) => onChange('spam', value)}
                >
                    <HeadingIconWrapper>
                        <Badge color="purple" variant="mini">
                            {t('badge_beta')}
                        </Badge>
                        <Popover
                            trigger={<InfoIcon />}
                            actionContent={
                                <StyledLink href="https://support.y.at/hc/en-us/articles/7619717723291-How-does-Yat-mark-NFT-collections-as-spam-">
                                    {t('filter_spam_tooltip_action')}
                                </StyledLink>
                            }
                            placement={isTablet ? 'bottom-start' : 'bottom-end'}
                        >
                            {t('filter_spam_tooltip')}
                        </Popover>
                    </HeadingIconWrapper>
                </Switch>
            </FilterContent>
        </AccordionItem>
    );
};
